export const getAuthSlice = (state) => state.auth;

export const getLoginKind = (state) => state.auth.loginKind;

export const getSystemConfig = (state) => state.auth.systemConfig;

export const getIsForceConfirmProfile = (state) =>
  state.auth.user?.isProfileForce && !state.auth.user?.isConfirmed;
